module.exports = __webpack_public_path__ + "img/icon-web-home-05.b118b928.png";